// jshint ignore: start

export default {
  "notificationsPopover": {
    "title": "CGTrader AI 通知",
    "indicator": {
      "lead": "模型生成中和完成时，你会在",
      "highlight": "顶部菜单看到提示",
      "rest": "。"
    },
    "emailToggle": "模型就绪时给我发送电子邮件",
    "browserToggle": "启用浏览器通知",
    "note": "只有当你尚未在CGTrader AI中查看该项目时，我们才会通知你。你可以随时在AI设置中更改偏好。",
    "save": "保存偏好设置",
    "close": "关闭"
  },
  "settingsModal": {
    "title": "设置",
    "tabs": {
      "usage": "用量",
      "notifications": "通知"
    },
    "notificationsTitle": "CGTrader AI 通知"
  },
  "seo": {
    "imagesTitle": "社区生成的AI图片 | CGTrader AI",
    "indexTitle": "3D AI生成器 | CGTrader",
    "galleryTitle": "社区生成的AI 3D模型 | CGTrader AI",
    "outputTitle": "{{name}} 3D模型 | CGTrader AI"
  },
  "waitlist": {
    "card": {
      "chip": "免费测试版",
      "freeGenerationsHighlight": "5 次免费生成",
      "freeGenerationsSuffix": "（CGTrader AI）",
      "noCreditCard": "无需信用卡",
      "gettingStarted": "非常适合入门和尝试",
      "join": "加入等候名单",
      "joining": "加入中...",
      "haveAccessCode": "我有访问码",
      "joinError": "无法加入等候名单。请重试。"
    },
    "accessCode": {
      "label": "输入免费测试版访问码",
      "placeholder": "输入您的访问码",
      "apply": "应用",
      "applying": "应用中...",
      "successMessage": "正在设置您的访问权限 - 准备就绪后我们会通知您。",
      "invalidMessage": "访问码无效。请重试。",
      "errorMessage": "无法验证访问码。请重试。"
    },
    "subscriptionBullets": {
      "monthly": "{{monthlyModels}} 次 CGTrader AI 生成或 Marketplace 下载",
      "editEnhance": "编辑和增强您自己或购买的 3D 模型",
      "engines": "包含所有顶级 AI 引擎：Tripo、Hunyuan、Meshy",
      "allAdvancedFeatures": "访问所有高级功能"
    }
  },
  "bestOnDesktop": {
    "title": "最适合桌面端",
    "description": "CGTrader AI 专为较大屏幕设计。部分编辑工具、设置和3D预览在移动设备上可能无法正确显示。为获得最佳体验，请切换到桌面端。"
  },
  "mobileTabBar": {
    "tabs": {
      "generate": "生成",
      "viewer": "3D模型",
      "enhance": "增强"
    }
  },
  "sidebar": {
    "header": {
      "title": "CGTrader AI"
    },
    "linkNav": {
      "generate": "3D模型生成器",
      "communityGallery": "社区画廊",
      "imageGenerator": "图像生成器",
      "community": "社区",
      "communityThreeDModels": "3D模型",
      "communityImages": "图片"
    },
    "usage": {
      "label": "用量"
    },
    "settings": {
      "label": "设置"
    },
    "termsOfService": {
      "label": "服务条款"
    },
    "status": {
      "processing": "处理中...",
      "generating": "生成中..."
    },
    "actions": {
      "generateNewModel": "生成新的3D模型"
    },
    "search": {
      "placeholder": "搜索"
    },
    "filtering": {
      "generated": "已生成",
      "purchased": "已购买",
      "uploaded": "已上传",
      "all": "全部",
      "favorites": "收藏",
      "drafts": "草稿"
    },
    "library": {
      "error": "加载失败！",
      "emptyState": {
        "text": "创建你的第一个3D模型，你的库将显示在此处",
        "imagesText": "创建图片，你的库将显示在此处"
      },
      "notFound": {
        "text": "未找到任何内容"
      },
      "tabs": {
        "models": "3D 模型",
        "images": "图片"
      }
    },
    "imageCard": {
      "notifications": {
        "deleteSuccess": "图片已成功删除。",
        "deleteError": "删除图片失败。请重试。"
      }
    },
    "modelCard": {
      "draft": "草稿",
      "makePrivate": "设为私密",
      "created": "创建时间：{{date}}",
      "delete": "删除",
      "variationsCount_0": "{{count}} 个变体"
    },
    "newModelCard": {
      "titleLine1": "生成新的",
      "titleLine2": "3D模型"
    },
    "useModelCard": {
      "titleLine1": "使用您的",
      "titleLine2": "3D 模型"
    }
  },
  "imageAssistantPanel": {
    "errors": {
      "downloadFailed": "下载失败，请重试。"
    },
    "title": "AI 图像助手",
    "actions": {
      "useForThreeDGeneration": "用于 3D 生成",
      "regenerate": "重新生成",
      "editImage": "编辑图像",
      "modifyImage": "修改图像",
      "download": "下载"
    },
    "createTab": {
      "composer": {
        "send": "生成新图像"
      },
      "newImageNote": "新的提示词将创建一张新图像。",
      "conversation": {
        "emptyPrompt": "你想创建什么？"
      },
      "result": {
        "expand": "以全尺寸打开图像",
        "lightbox": "生成的图像"
      },
      "generatingState": {
        "label": "正在创建你的图像..."
      },
      "failedState": {
        "title": "生成失败",
        "text": "生成图像时出了点问题。请重试。",
        "retry": "重新生成"
      }
    },
    "editTab": {
      "back": "返回",
      "composer": {
        "placeholder": "描述要更改的内容（例如：移除背景、简化细节）",
        "placeholderWithImageTools": "描述要更改的内容（例如：移除背景、放大、调整或简化细节）"
      },
      "emptyState": {
        "title": "要编辑图像，请先上传、搜索或创建图像",
        "titleWithoutSearch": "要编辑图像，请先上传或创建图像",
        "subtitle": "支持文本指令和图像修复"
      },
      "toolbar": {
        "version": "版本 {{number}}",
        "originalVersion": "原图",
        "history": "历史记录",
        "removeBackground": "移除背景",
        "upscale": "放大",
        "versionKind": {
          "brush": "画笔工具",
          "prompt": "提示词"
        }
      },
      "promptViewer": {
        "toggleLabel": "显示此版本使用的提示词",
        "copyLabel": "复制提示词",
        "copiedLabel": "已复制",
        "copiedNotification": "提示词已复制到剪贴板"
      }
    },
    "searchTab": {
      "searchPlaceholder": "搜索参考图像",
      "categoriesHeading": "搜索最多的图像类别",
      "loading": "正在加载搜索结果...",
      "noResults": {
        "title": "未找到任何内容",
        "subtitle": "尝试使用你的提示词创建参考图像",
        "create": "创建图像"
      }
    }
  },
  "usageModal": {
    "header": {
      "unlockAiGeneration": "解锁 AI 生成",
      "betaAccessRequested": "已申请 Beta 访问权限",
      "aiUsage": "CGTrader AI 用量"
    },
    "tags": {
      "freePlan": "免费方案",
      "subscription": "CGTrader 订阅"
    },
    "setupHeadline": "你已完成所有设置 - 现在解锁生成功能，让它成为现实。",
    "terms": {
      "leadDefault": "继续使用 CGTrader AI 即表示你同意",
      "leadWaitlisted": "继续即表示我同意",
      "tosLink": "CGTrader AI 服务条款"
    },
    "extraUsage": {
      "titleWithPrice": "以 {{price}} 获取 {{count}} 次额外生成",
      "title": "获取 {{count}} 次额外生成",
      "subtitle": "不间断地持续创作",
      "cta": "购买额外用量",
      "note": "额外用量不会过期，也不会每月重置。"
    },
    "freeBeta": {
      "outOfGenerations": "你的免费生成次数已用完",
      "almostOutOfGenerations": "你的免费生成次数即将用完",
      "generationsUsedLabel": "已使用生成次数"
    },
    "freeBetaCard": {
      "successMessage": "一切就绪！开始创建你的3D模型。",
      "errorMessage": "无法启动你的免费 Beta。请重试。",
      "chip": "免费 Beta",
      "freeGenerations": "5 次免费生成",
      "inStudio": " 在 CGTrader AI Studio 中",
      "noCreditCard": "无需信用卡",
      "gettingStarted": "非常适合入门和尝试",
      "starting": "启动中...",
      "cta": "免费开始创作"
    },
    "hasCredits": {
      "creditsLeft_0": "你还剩 {{count}} 个额度"
    },
    "subscribed": {
      "outOfGenerations": "你的生成次数已用完",
      "monthlyGenerationsUsedLabel": "已使用每月生成次数",
      "generationsRatioTooltip": "10 次图像生成相当于 1 次常规 3D 生成",
      "extraGenerationsUsedLabel": "已使用额外生成次数",
      "resetDateLabel": "重置日期：",
      "subscriptionSettings": "前往订阅设置"
    },
    "subscriptionCard": {
      "priceUnit": "/ 月",
      "cta": "获取订阅"
    },
    "upgrade": {
      "title": "升级以开始创作"
    },
    "upgradeCard": {
      "defaultTitle": "升级以继续创作",
      "priceUnit": "/ 月",
      "cta": "获取订阅"
    },
    "paidFeature": {
      "title": "升级以更自由地创作",
      "advancedFeaturesTitle": "解锁高级功能：",
      "advancedFeatures": {
        "private": "将您的模型设为私密，仅您可以查看和分享",
        "dccBridge": "DCC Bridge 集成，实现无缝工作流程",
        "export": "以任何受支持的格式导出模型",
        "multipleModels": "同时生成多个模型"
      }
    },
    "waitlisted": {
      "onWaitlist": "你已加入候补名单！",
      "copy": "我们会审核你的请求，并在开放访问后通过电子邮件通知你。",
      "accessCode": "我有访问码",
      "upgradeTitle": "通过订阅更快获得访问权限"
    }
  },
  "viewerSidebar": {
    "nav": {
      "enhance3dModel": "增强3D模型",
      "remesh": "重构网格",
      "texture": "贴图",
      "segment": "分割",
      "animate": "动画",
      "render": "渲染",
      "variations": "变体",
      "assist": "协助",
      "disabledReason": "生成或上传模型以开始编辑",
      "variationsNotOwnerReason": "变体仅适用于你自己的模型"
    },
    "enhance": {
      "common": {
        "done": "完成",
        "processing": "处理中..."
      },
      "remesh": {
        "title": "重构网格",
        "generateLabel": "重构网格",
        "smartLowPoly": "智能低多边形",
        "polycount": {
          "label": "多边形数量",
          "low": "低",
          "medium": "中",
          "high": "高"
        },
        "example": {
          "highPoly": "高多边形网格",
          "optimized": "优化网格"
        }
      },
      "texture": {
        "title": "贴图",
        "generateLabel": "生成贴图",
        "textPlaceholder": "描述你想为此模型生成的贴图",
        "material": {
          "label": "材质",
          "pbr": "PBR",
          "basic": "基础材质"
        },
        "resolution": {
          "label": "分辨率",
          "2k": "2K",
          "4k": "4K",
          "8k": "8K"
        },
        "preview": {
          "initial": "初始贴图",
          "new": "新贴图"
        }
      },
      "segment": {
        "title": "分割",
        "riggedTooltip": "分割不适用于绑定骨骼的模型。",
        "placeholderTitle": "分割",
        "placeholderDescription": "自动将你的3D模型分割成可编辑的部件",
        "explodedView": "爆炸视图",
        "resetModel": "重置模型",
        "partList": "部件列表",
        "generateLabel": "开始分割",
        "generatingLabel": "分割中...",
        "unavailable": {
          "title": "不适用于",
          "quad": "四边形模型",
          "rigged": "绑定骨骼的模型"
        }
      },
      "animate": {
        "title": "动画",
        "description": "使用智能运动控制为你的3D模型制作动画",
        "rigDescription": "为模型绑定骨骼以制作动画",
        "generateLabel": "动画",
        "searchPlaceholder": "搜索动画",
        "noResults": "未找到动画"
      },
      "render": {
        "title": "渲染2D",
        "description": "在几秒内为你的3D模型创建高质量渲染",
        "viewerHint": "在查看器中调整3D模型的位置",
        "promptLabel": "文本提示",
        "promptPlaceholder": "添加最终效果的细节，例如电影级灯光、柔和阴影、影棚背景",
        "styleLabel": "风格",
        "styleNone": "无",
        "generateLabel": "渲染图像",
        "stylePanel": {
          "title": "选择风格",
          "close": "关闭风格选择器",
          "searchPlaceholder": "搜索风格",
          "categoriesLabel": "风格类别"
        }
      },
      "variations": {
        "title": "变体",
        "emptyState": "增强或重新生成你的模型。新的变体将显示在此处。",
        "uploaded": "已上传",
        "menu": {
          "created": "创建时间：{{date}}",
          "setAsMain": "设为主模型",
          "delete": "删除"
        },
        "notifications": {
          "setAsMainSuccess": "\"{{name}}\" 已成功设为主模型",
          "setAsMainError": "设置变体为主模型失败。请重试。",
          "deleteSuccess": "\"{{name}}\" 已成功删除",
          "deleteError": "删除变体失败。请重试。"
        }
      },
      "assist": {
        "heading": "请求设计师协助",
        "placeholderDescription": "在你需要时随时获得真实设计师的帮助",
        "form": {
          "title": {
            "label": "标题",
            "placeholder": "在此输入..."
          },
          "description": "描述",
          "budget": "预算",
          "resell": "我允许设计师在市场上出售项目成果",
          "terms": {
            "agree": "我同意 ",
            "link": "条款与条件"
          },
          "submit": "发布项目",
          "loadSoftwareError": "加载3D软件失败",
          "submitError": "出了点问题，请重试"
        },
        "deadline": {
          "label": "截止日期",
          "noFixed": "无固定截止日期"
        },
        "software": {
          "label": "3D软件",
          "placeholder": "选择3D软件"
        },
        "references": {
          "label": "视觉参考",
          "note": "我们会分享所使用的输入。你也可以添加参考。",
          "untitledModel": "未命名模型",
          "dropzone": {
            "title": "将参考图像拖放到此处",
            "or": "或",
            "browse": "浏览"
          },
          "errors": {
            "uploadFailed": "文件附加失败。请重试或联系我们的支持团队",
            "onlyImages": "只能附加图像文件。",
            "tooBig": "附件过大，请勿超过100MB。",
            "duplicate": "你无法附加同名文件"
          }
        },
        "posted": {
          "title": "请求已提交",
          "description": "你的项目已发布到自由设计师的公开列表。有人申请时你会收到通知",
          "cta": "前往我的3D项目"
        }
      }
    }
  },
  "shared": {
    "aiEngine": {
      "label": "AI引擎",
      "disabledTooltip": "此设置组合不可用"
    },
    "polyCount": {
      "label": "多边形数量",
      "low": "低",
      "medium": "中",
      "high": "高"
    },
    "polygonType": {
      "label": "多边形类型",
      "quad": "四边形",
      "triangular": "三角形"
    },
    "placeholder": {
      "comingSoon": "即将推出"
    },
    "subscribersOnly": {
      "title": "仅限订阅者",
      "simultaneousGenerationsTitle": "同时进行多项生成仅对订阅者开放",
      "getSubscription": "获取订阅"
    },
    "uploadModel": {
      "uploading": "上传中...",
      "upload": "使用您的3D模型"
    },
    "shareContent": {
      "embedButtonLabel": "嵌入此3D模型"
    },
    "generateButton": {
      "inProgressTooltip": "当前有另一项生成正在进行中。完成后即可使用此操作。",
      "limitReachedTooltip": "您已达到可同时进行的生成数量上限。其中一项完成后即可使用此操作。",
      "sameSettingsTooltip": "此生成已在进行中。更改任意设置即可开始另一次生成。",
      "genericError": "生成失败。请重试。"
    },
    "privateMode": {
      "label": "私密模式",
      "tooltip": "在私密模式下，只有您可以查看和分享该模型。如果未启用私密模式，该模型可能会显示在社区展示库中，其他用户可以查看并进行二次创作。"
    },
    "actionSelector": {
      "tabs": {
        "singleImage": "单张图片",
        "multiView": "多视角",
        "multiViewTooltip": "从多个角度上传同一物体，可生成更精确的3D模型。正面视图为必填项。",
        "image": "图片",
        "text": "文本"
      },
      "textInstructions": {
        "maxCharacters": "最多允许{{maxLength}}个字符"
      },
      "imageUploader": {
        "multiView": {
          "required": "必填",
          "title": "多视角图片上传",
          "upload": "上传{{view}}视图图片",
          "remove": "移除{{view}}视图图片",
          "preview": "{{view}}视图预览",
          "views": {
            "front": "正面",
            "left": "左侧",
            "right": "右侧",
            "back": "背面",
            "top": "顶部",
            "bottom": "底部",
            "leftFront": "左前",
            "rightFront": "右前"
          }
        },
        "uploadPrompt": {
          "dropHere": "将图片拖放到此处或",
          "browse": "浏览",
          "fileTypes": "PNG、JPG、WEBP"
        },
        "pasteUrl": {
          "placeholder": "图片URL",
          "upload": "上传图片"
        },
        "preview": {
          "edit": "编辑此图片"
        },
        "ideation": {
          "search": "搜索图片",
          "create": "创建图片",
          "edit": "编辑图片"
        }
      }
    },
    "composer": {
      "placeholder": "描述对象和视角（例如：电动跑车，前方3/4视角）"
    },
    "dccNotification": {
      "connecting": "正在连接插件...",
      "sending": "正在将3D模型发送到{{name}}...",
      "success": "3D模型已发送到{{name}}",
      "pluginNotRunning": {
        "title": "插件未运行",
        "descriptionWithName": "请确保您的DCC已打开，并且{{name}}的插件已安装并正在运行。",
        "description": "请确保您的DCC已打开，并且插件已安装并正在运行。"
      },
      "dccBusy": {
        "title": "DCC正忙",
        "description": "它仍在处理上一次导入。请稍后重试。"
      },
      "error": {
        "title": "出了点问题",
        "description": "发送模型时出现问题。请重试。"
      }
    },
    "deleteConfirmModal": {
      "header": "删除{{itemType}}？",
      "submit": "删除",
      "cancel": "取消",
      "bodyNamed": "“{{itemName}}”将被永久删除。此操作无法撤销。",
      "bodyGeneric": "此{{itemType}}将被永久删除。此操作无法撤销。",
      "itemTypes": {
        "item": "项目",
        "model": "模型",
        "variation": "变体",
        "comment": "评论",
        "reply": "回复",
        "image": "图片"
      }
    },
    "exportNotification": {
      "queued": {
        "title": "文件已添加到队列。",
        "description": "您的导出即将开始。"
      },
      "preparing": {
        "title": "正在准备您的文件以供下载。"
      },
      "error": {
        "title": "出了点问题",
        "description": "我们无法完成导出。请重试。"
      }
    }
  },
  "leftSide": {
    "generate": {
      "generate": "生成3D模型",
      "regenerate": "重新生成3D模型",
      "generated": "已生成",
      "generating": "生成中..."
    },
    "modelSettings": {
      "promptPlaceholder": "描述你想创建的内容"
    },
    "useCase": {
      "title": "使用场景",
      "options": {
        "standard": {
          "title": "标准",
          "description": "适用于大多数情况。质量与多边形数量均衡，带PBR贴图。"
        },
        "hero": {
          "title": "主体资产",
          "description": "最高质量。密集四边形网格搭配完整PBR - 适合高质量资产。"
        },
        "prop": {
          "title": "道具资产",
          "description": "多边形数量适中的游戏就绪道具。"
        },
        "threeDPrint": {
          "title": "3D打印",
          "description": "适用于3D打印的高密度三角网格，带基础材质。"
        },
        "shapeOnly": {
          "title": "仅形状",
          "description": "无贴图的高密度网格。适合验证几何体和表面细节。"
        },
        "lowPoly": {
          "title": "低多边形",
          "description": "带PBR贴图的低多边形网格。"
        }
      }
    },
    "material": {
      "label": "材质",
      "pbr": "PBR",
      "basic": "基础",
      "geometryOnly": "仅几何体",
      "geometry": "几何体"
    },
    "extraQuality": {
      "label": "超高质量",
      "badge": "新",
      "hint": "用量翻倍，生成时间更长"
    },
    "smartLowPoly": {
      "label": "智能低多边形",
      "collapsedLabel": "低多边形"
    },
    "advancedSettings": {
      "trigger": "高级设置"
    },
    "polyCount": {
      "label": "多边形数量",
      "low": "低",
      "medium": "中",
      "high": "高"
    },
    "polygonType": {
      "label": "多边形类型",
      "quad": "四边形",
      "triangular": "三角形"
    },
    "aiEngine": {
      "label": "AI引擎"
    },
    "actionPreview": {
      "title": "输入"
    }
  },
  "header": {
    "modelSettings": "生成3D模型",
    "viewer": "3D模型"
  },
  "community": {
    "card": {
      "remix": "混编 {{title}}",
      "remixBy": "混编 {{username}} 的 {{title}}"
    }
  },
  "imageGallery": {
    "card": {
      "open": "打开{{title}}",
      "edit": "编辑{{title}}",
      "download": "下载{{title}}",
      "generate3d": "生成3D",
      "generate3dFor": "根据{{title}}生成3D模型"
    },
    "categories": {
      "all": "全部",
      "aircraft": "飞行器",
      "animals": "动物",
      "architectural": "建筑",
      "exterior": "外观",
      "interior": "室内",
      "car": "汽车",
      "character": "角色",
      "military": "军事",
      "furniture": "家具",
      "food": "食物",
      "plant": "植物",
      "science": "科学",
      "space": "太空",
      "sports": "运动",
      "vehicle": "交通工具",
      "watercraft": "船舶"
    },
    "modal": {
      "ariaLabel": "图片 {{title}}",
      "previous": "上一张图片",
      "next": "下一张图片",
      "edit": "编辑",
      "download": "下载",
      "createdBy": "由 {{username}} 创建",
      "prompt": "提示词",
      "copyPrompt": "复制提示词",
      "expandPrompt": "显示完整提示词",
      "collapsePrompt": "收起提示词",
      "generationSettings": "生成设置",
      "settings": {
        "reference": "参考图",
        "baseModel": "基础模型",
        "aspectRatio": "宽高比",
        "style": "风格",
        "resolution": "图片分辨率",
        "seed": "种子"
      },
      "similarImages": "相似图片"
    },
    "downloadFailed": "下载失败，请重试。",
    "loadError": "图片加载失败。",
    "searchPlaceholder": "搜索",
    "moreCategories": "更多",
    "empty": {
      "title": "未找到符合条件的图片",
      "description": "请尝试调整搜索或选择其他筛选条件",
      "clearFilters": "清除筛选"
    }
  },
  "commentsModal": {
    "ariaLabel": "评论",
    "placeholder": "欢迎在此分享你的想法。",
    "replyPlaceholder": "在此输入你的回复",
    "post": "发布",
    "reply": "回复",
    "delete": "删除",
    "deleteCommentBy": "删除{{username}}的评论",
    "deleteReplyBy": "删除{{username}}的回复",
    "relativeTime": {
      "year": "{{count}}年",
      "month": "{{count}}个月",
      "week": "{{count}}周",
      "day": "{{count}}天",
      "hour": "{{count}}小时",
      "minute": "{{count}}分钟",
      "second": "{{count}}秒"
    },
    "hide": "隐藏",
    "creatorBadge": "模型创作者",
    "commentsCount_0": "{{count}} 条评论",
    "repliesCount_0": "{{count}} 条回复",
    "empty": "还没有评论。快来第一个分享你的想法吧。",
    "loadError": "无法加载评论。",
    "submitError": "出了点问题，请重试。",
    "limitReached": "您暂时已达到评论上限，请稍后再试。",
    "loginPrompt": "登录以加入讨论。",
    "login": "登录"
  },
  "like": {
    "likeModel": "点赞 {{title}}",
    "unlikeModel": "取消点赞 {{title}}",
    "like": "点赞",
    "unlike": "取消点赞",
    "dailyLimitReached": "您已达到今日点赞上限。请明天再试。"
  },
  "likers": {
    "title_0": "{{count}} 个赞",
    "openList": "查看谁赞了此模型",
    "close": "关闭",
    "relativeTime": {
      "day": "{{count}}天前",
      "hour": "{{count}}小时前",
      "minute": "{{count}}分钟前",
      "second": "{{count}}秒前"
    }
  },
  "footerActions": {
    "delete": "删除",
    "share": "分享",
    "creator": {
      "createdBy": "创作者：{{username}}"
    },
    "export": {
      "label": "导出"
    },
    "dccBridge": {
      "tooltip": "请先安装并运行插件，以将模型发送到相应的DCC软件",
      "comingSoon": "即将推出",
      "downloadPluginButton": "下载插件",
      "guide": "指南"
    },
    "sendTo": {
      "label": "发送到",
      "labelWithName": "发送到{{name}}",
      "needHelp": "需要帮助？",
      "setupGuide": "查看设置指南",
      "downloadPlugin": "下载插件",
      "step1": "下载并安装插件",
      "step2": "启动你的DCC并确保插件正在运行",
      "step3": "将模型直接发送到你的DCC。"
    },
    "modelTitle": {
      "updateSuccess": "模型标题更新成功。",
      "updateError": "模型标题更新失败。"
    }
  },
  "viewer": {
    "banner": {
      "phase": {
        "queued": "正在排队等待...",
        "analyzing": "正在分析你的输入...",
        "generating": "正在生成你的3D模型...",
        "refining": "正在优化细节...",
        "finalizing": "正在完成你的3D模型..."
      },
      "phaseTimeLeft": {
        "minutes": "剩余约{{minutes}}分钟",
        "lessThanMinute": "剩余不到1分钟"
      },
      "slotsNotice": {
        "highlight": "{{total}}个同时生成名额中还剩{{available}}个",
        "rest": "可在你的方案中使用。继续创建或编辑你的模型吧！"
      },
      "unlockFeatures": {
        "title": "解锁高级功能",
        "cta": "获取订阅",
        "simultaneousGenerations": "最多同时生成5个模型",
        "queuePriority": "队列优先",
        "privateMode": "私密模式",
        "dccBridge": "DCC Bridge",
        "modelDownloads": "3D模型下载"
      },
      "initial": "你的3D模型将显示在此处",
      "generatingTitle": "正在生成你的3D模型",
      "generatingDescription": "这可能需要几分钟。准备就绪时，你会在顶部菜单看到提示。我们还会发送电子邮件通知你，以免错过。",
      "loadingTitle": "正在加载3D模型",
      "uploadingTitle": "正在上传你的3D模型...",
      "uploadingDescription": "这可能需要一点时间。复杂模型的加载时间可能更长。",
      "cleverPush": {
        "prompt": "即使切换标签页也能收到通知",
        "allow": "允许浏览器通知"
      },
      "relatedProducts": {
        "title": "你可能还喜欢",
        "viewMore": "在市场中查看更多"
      }
    },
    "errorBanner": {
      "tryAgain": "重新{{action}}",
      "title": "出了点问题",
      "description": "我们无法完成此操作。请尝试调整设置、简化你的输入或检查参考内容。",
      "errorId": "错误ID",
      "reason": "原因",
      "message": "消息",
      "providerCode": "提供方代码"
    },
    "modelReadyToaster": {
      "message": "你的模型已就绪！现在可以探索增强工具来优化和自定义它。",
      "dontShowAgain": "不再显示"
    },
    "remixNotice": {
      "title": "你正处于混编模式",
      "description": "调整设置、重新生成并增强此3D模型，创建你自己的版本。新创作将保存到你的库中。",
      "tag": "混编模式"
    },
    "termsOfServiceNotice": {
      "lead": "请注意，继续使用 CGTrader AI 即表示你同意",
      "link": "CGTrader AI 服务条款"
    },
    "canvas": {
      "failedToStart": "启动失败"
    },
    "environment": {
      "title": "环境设置",
      "strength": "强度",
      "rotation": "旋转",
      "uploadHdri": "上传HDRI",
      "surrounding": "环境背景",
      "showDefaultHdri": "显示默认HDRI",
      "showHdri": "显示HDRI",
      "uploadFailed": "HDRI上传失败。请重试。",
      "added": "已将\"{{label}}\"添加到环境背景。"
    },
    "sidebar": {
      "lighting": "灯光 (L)",
      "toggleGrid": "切换网格 (G)",
      "autoRotate": "切换自动旋转 (R)",
      "resetCamera": "重置相机 (F)"
    },
    "renderMode": {
      "pbr": "PBR (M)",
      "clay": "黏土 (C 循环切换)",
      "baseColor": "仅基础色 (C 循环切换)",
      "roughness": "仅粗糙度 (C 循环切换)",
      "normals": "仅法线 (C 循环切换)",
      "metalness": "仅金属度 (C 循环切换)",
      "segmentation": "分割 (C 循环切换)",
      "wireframe": "线框 (W)"
    },
    "animationPlayer": {
      "play": "播放动画",
      "pause": "暂停动画",
      "timeline": "动画时间轴",
      "progress": "{{total}} 中的 {{current}}"
    },
    "modelDetails": {
      "faces": "面",
      "vertices": "顶点",
      "aiEngine": "AI引擎",
      "extraQuality": "超高",
      "lowPoly": "低多边形",
      "polycount": "多边形数量",
      "polygonType": "多边形类型",
      "material": "材质",
      "true": "是",
      "false": "否",
      "materialBasic": "基础",
      "materialGeometryOnly": "仅几何体"
    }
  },
  "signIn": {
    "header": {
      "signupTitle": "创建账户即可开始",
      "cgdreamSignupTitle": "登录以继续使用 CGTrader AI",
      "loginTitle": "欢迎回来",
      "signupSubtitle": "我们将向您发送一个6位数验证码，让您无需创建密码即可登录。",
      "loginSubtitle": "登录以继续创作、设计和下载。"
    },
    "auth": {
      "divider": "或",
      "optIn": "接收产品更新、社区新闻和优惠信息。"
    },
    "email": {
      "label": "电子邮箱",
      "placeholder": "john@email.com",
      "ariaLabel": "电子邮箱地址"
    },
    "footer": {
      "submit": "继续",
      "haveAccount": "已有账户？",
      "noAccount": "还没有账户？",
      "login": "登录",
      "signup": "注册"
    },
    "terms": {
      "prefix": "继续即表示我同意",
      "termsLink": "通用条款和条件",
      "and": "以及",
      "privacyLink": "隐私政策。"
    },
    "code": {
      "title": "查收您的电子邮件",
      "subtitlePrefix": "我们已将6位数验证码发送至",
      "yourEmail": "您的电子邮箱",
      "invalidCode": "访问代码无效。请重试。",
      "resendPrompt": "没有收到邮件？",
      "resendAction": "点击重新发送",
      "digitAriaLabel": "第 {{index}} 位"
    },
    "success": {
      "title": "您已成功登录！",
      "loginSubtitle": "您已登录。从上次中断的地方继续吧！",
      "signupSubtitle": "账户已创建。生成您的第一个3D模型吧！"
    },
    "modal": {
      "loginAriaLabel": "登录 CGTrader AI",
      "signupAriaLabel": "注册 CGTrader AI",
      "successAriaLabel": "您已成功登录"
    },
    "password": {
      "link": "改用密码登录",
      "emailLabel": "邮箱或用户名",
      "title": "使用密码登录",
      "subtitle": "请输入您的邮箱和密码以继续。",
      "passwordLabel": "密码",
      "forgotPassword": "忘记密码？",
      "submit": "登录",
      "back": "返回",
      "showPassword": "显示密码",
      "hidePassword": "隐藏密码",
      "genericError": "出了点问题。请稍后再试。",
      "requiredNotice": "请同时输入您的密码以完成 2FA。",
      "twoFaTitle": "请输入您的登录验证码",
      "twoFaDescription": "验证码已发送到您用于登录 CGTrader 账户的邮箱地址",
      "twoFaVerify": "验证",
      "twoFaCodeLabel": "验证码"
    }
  },
  "threeDModelPicker": {
    "title": "选择或上传 3D 模型",
    "purchasesHeading": "我的购买",
    "searchPlaceholder": "搜索 3D 模型",
    "uploadTile": "上传 3D 模型",
    "submit": "使用所选 3D 模型",
    "error": "无法加载您已购买的模型。请重试。",
    "notFound": "没有与“{{keywords}}”匹配的已购买模型。",
    "cardLabel": "选择 {{title}}",
    "cardUnsupportedLabel": "{{title}} 没有查看器可以打开的文件",
    "openError": "无法打开此 3D 模型。请重试。",
    "empty": {
      "title": "您还没有可选择的已购买模型",
      "description": "上传您自己的模型，或浏览市场。",
      "searchMarketplace": "在市场中搜索"
    }
  }
}
